import axios from "axios";
import { BACKEND_BASE_URL } from "./baseurl";
import useEncryption from "../utils/hooks/useEncryption";
const BACKEND_URL = BACKEND_BASE_URL;
const axiosInstance = axios.create({ baseURL: BACKEND_URL });

// Production API always encrypts; local server (NODE_ENV=development) returns plain JSON.
const isPlainApiMode = process.env.REACT_APP_PROJECT_MODE === "development";

// Add a request interceptor
axiosInstance.interceptors.request.use(
  async function (config) {
    // Keep auth optional when not logged in (public pages).
    try {
      const user = localStorage.getItem("user");
      if (user) {
        const authData = JSON.parse(user)?.auth;
        const token =
          typeof authData === "string"
            ? JSON.parse(authData)?.session?.token
            : authData?.session?.token;
        if (token) {
          config.headers = {
            ...config.headers,
            Authorization: `${token}`,
            Accept: "application/json",
            "Content-Type": "multipart/form-data;",
          };
        }
      }
    } catch (e) {
      // Ignore corrupt localStorage auth; continue without token.
    }
    // Do something before request is sent
    const formData = new FormData();
    if (config.data) {
      if (config?.data?.file) {
        formData.append("file", config?.data?.file);
        delete config?.data?.file;
      }
      if (config?.data?.files) {
        formData.append("files", config?.data?.files);
        delete config?.data?.files;
      }
      if (config?.data?.path && !formData.has("file")) {
        // path-only delete flows still need the body
      }
      if (isPlainApiMode) {
        formData.append("data", JSON.stringify(config.data));
      } else {
        formData.append("data", await useEncryption.encryptData(config.data));
      }
    }
    config.data = formData;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  async function (response) {
    const payload = response?.data;
    // CryptoJS ciphertext is a string (often starts with "U2FsdGVkX1").
    // Production API returns encrypted strings even when the local app is in "development".
    if (typeof payload === "string") {
      return await useEncryption.decryptData(payload);
    }
    return payload;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axiosInstance;
